import styled from 'styled-components';

import { devices } from 'shared/styles/components';

export const AboutContainer = styled.div`
  margin: auto;
  padding: 48px 24px;
  max-width: 840px;

  a {
    color: ${({ theme }) => theme.colors.textTertiary};

    &:hover {
      text-decoration: underline;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.textPrimary};
    font-size: 24px;
  }

  @media ${devices.tabletMax} {
    p {
      font-size: 18px;
    }
  }
`;

export const AboutDivider = styled.div`
  margin: 56px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const AboutFoundersWrapper = styled.div`
  display: grid;
  margin: 56px auto;
  grid-auto-columns: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;

  @media ${devices.mobileMax} {
    grid-row-gap: 32px;
  }

  @media ${devices.tabletMax} {
    max-width: 90%;
    margin-top: 40px;
    grid-column-gap: 80px;
    grid-row-gap: 80px;
    grid-template-columns: 1fr;
  }
`;

export const AboutFounder = styled.div`
  grid-column-start: span 1;
  grid-row-start: span 1;
  grid-row-end: span 1;

  h3 {
    color: ${({ theme }) => theme.colors.textEmphasis};
    margin-bottom: 8px;
  }

  h4 {
    margin-bottom: 6px;
    color: ${({ theme }) => theme.colors.textSecondary};
    font-family: ${({ theme }) => theme.fontFamily.display};
  }

  .ichthus:hover ~ div > a > svg.ichthus {
    fill: ${({ theme }) => theme.colors.warning};
    filter: drop-shadow(0 0 7px ${({ theme }) => theme.colors.warning});
  }
`;

export const AboutFounderImage = styled.div`
  position: relative;
  margin-bottom: 40px;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 16px;

  img {
    object-fit: cover;
    object-position: center top;
  }
`;

export const AboutFounderSocials = styled.div`
  display: flex;
  margin-bottom: 20px;

  a {
    height: 20px;
    margin-right: 4px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  svg.email {
    margin-top: 2px;
  }

  svg.ichthus {
    fill: ${({ theme }) => theme.colors.bgPrimary};

    &:hover {
      fill: ${({ theme }) => theme.colors.warning};
      filter: drop-shadow(0 0 7px ${({ theme }) => theme.colors.warning});
    }
  }

  svg {
    fill: ${({ theme }) => theme.colors.textPrimary};
    width: 20px;
    height: 20px;
    transition: fill 0.2s;

    &:hover {
      fill: ${({ theme }) => theme.colors.textTertiary};
    }
  }
`;

export const AboutFounderDescription = styled.div`
  margin-bottom: 8px;
  font-size: 16px;
`;
